/* eslint-disable react-hooks/exhaustive-deps */
import { FloatButton, Layout } from 'antd';
import { useAppDispatch, useAppNavigation, useAuthState, useBusinessState } from '@core/.';
import { AppRoutes } from '@utils/.';
import {
  RequestCreationScreen,
  RequestEmailSMSScreen,
  AutoRequestScreen,
  RequestQrCodeScreen,
  RestogramStudioScreen,
  ReviewsScreen,
  SettingsScreen,
  WidgetScreen,
  HomeScreen,
  WelcomeHomeScreen,
  ManualSharingScreen,
  InquiryScreen,
  AppIntegrationScreen,
  SubscriptionScreen,
} from '@pages/.';
import AppBar from '../AppBar';
import LeftSider from '../LeftSider';
import ModalContainer from '@components/ModalContainer';
import { useHistory, useParams } from 'react-router';
import React, { useEffect } from 'react';
import { fetchReviewRequests } from '@core/features/review-request/thunks';
import { openModal } from '@core/features';
import SplashScreen from '@components/SplashScreen';
import { TbHelp } from 'react-icons/tb';
import { fetchLocationData } from '@core/features/business/thunks';
import { fetchInquiries } from '@core/features/inquiry/thunks';

type Props = {};

const screens: Record<AppRoutes, any> = {
  home: <HomeScreen />,
  requests: <></>,
  reviews: <ReviewsScreen />,
  inquiries: <InquiryScreen />,
  integrations: <AppIntegrationScreen />,
  studio: <RestogramStudioScreen />,
  settings: <SettingsScreen />,
  requestCreation: <RequestCreationScreen />,
  manualSharing: <ManualSharingScreen />,
  widget: <WidgetScreen />,
  requestEmailSMS: <RequestEmailSMSScreen />,
  requestQrScanner: <RequestQrCodeScreen />,
  autoRequest: <AutoRequestScreen />,
  subscription: <SubscriptionScreen />,
  'getting-started': <WelcomeHomeScreen />,
};

const { Content } = Layout;

const DashboardLayout: React.FC = (props: Props) => {
  const history = useHistory();
  const { tabName } = useParams<{ tabName: AppRoutes }>();
  const { navigate } = useAppNavigation();
  const { error } = useBusinessState();
  const { user, isLoading: isLoadingUser } = useAuthState();
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!screens[tabName]) {
      navigate('home');
    }
  }, [tabName]);

  useEffect(() => {
    if (!user?.selected_location || error === 'MISSING_PERMISSION') {
      dispatch(
        openModal({
          modalName: 'welcomeLocationModal',
        })
      );
    }
  }, [error]);

  useEffect(() => {
    const init = async () => {
      await dispatch(fetchLocationData());
      await dispatch(fetchReviewRequests());
      await dispatch(fetchInquiries());
    };
    init();
  }, []);

  return user && !isLoadingUser ? (
    <Layout style={{ minHeight: '100vh' }}>
      <LeftSider />
      <Layout className="site-layout">
        <AppBar />
        <Content style={{ height: '80vh', overflow: 'auto' }}>
          {screens[tabName] || <React.Fragment>No route found</React.Fragment>}
        </Content>
        <ModalContainer />
      </Layout>
      <FloatButton
        onClick={() => history.push('/app/getting-started')}
        tooltip={'Help'}
        shape="square"
        icon={<TbHelp />}
        style={{ left: 30, bottom: 30 }}
        type="primary"
      />
    </Layout>
  ) : (
    <SplashScreen />
  );
};

export default DashboardLayout;
